"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log ke console
    console.error("[APP ERROR]", error);

    // Kirim log ke file via API
    fetch("/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        level: "ERROR",
        message: `[APP ERROR] ${error.message}`,
        data: {
          digest: error.digest,
          stack: error.stack,
        },
      }),
    }).catch(() => {
      // Ignore fetch errors
    });

    // Auto-reload jika ChunkLoadError (setelah deploy baru)
    if (
      error.message.includes("Loading chunk") ||
      error.message.includes("ChunkLoadError") ||
      error.name === "ChunkLoadError"
    ) {
      // Reload halaman untuk mendapat versi terbaru
      window.location.reload();
    }
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">
          Terjadi Kesalahan
        </h2>
        <p className="text-gray-600 mb-6">
          {error.message || "Maaf, terjadi kesalahan pada halaman ini."}
        </p>
        <button
          onClick={() => reset()}
          className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          Coba Lagi
        </button>
      </div>
    </div>
  );
}
